<template>
  <v-app>
    <div>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <v-app-bar app :color="$blue" class="top-nav" flat>
        <v-toolbar-title>
          <a :href="portalURL">
            <v-img
              src="@/assets/asr-logo-01.png"
              class="my-2"
              min-width="200"
              max-width="300"
              contain
            ></v-img>
          </a>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-img
          src="@/assets/digicap-logo-02.png"
          class="my-2 pt-1"
          min-width="100"
          max-width="150"
          contain
        ></v-img>
      </v-app-bar>
    </div>

    <v-content>
      <MainPage />
    </v-content>
  </v-app>
</template>

<script>
import MainPage from "./pages/main.page";
import { ASRPORTAL_URL } from "./constants/urls";

export default {
  name: "App",
  components: {
    MainPage
  },
  data: () => ({
    portalURL: ASRPORTAL_URL
  })
};
</script>

<style>
.top-nav {
  height: 40px;
}
</style>
